export const PoppingResize = (instance) => {
	const resize = () => {
		instance.updatePosition();
	};
	const clean = setTimeout(
		() => window.addEventListener('resize', resize, false),
		500
	);

	return {
		destroy() {
			clearTimeout(clean);
			window.removeEventListener('resize', resize, false);
		},
	};
};
